<template>
  <b-form>
    <b-row>
      <b-card
        no-body
        class="mb-0"
      >
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="activityTable"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          :empty-html="
          isLoading
            ? `<div class='text-center'><span class='fa fa-spinner fa-spin'></span> Loading...</div>`
            : `Sorry! No tickets found for selected criteria.`
        "        >
          <template #cell(profileImage)="data">
            <b-avatar :src="data.item._id.profileImage" />
          </template>
          <template #cell(username)="data">
            <b-link
              :to="{ name: 'userprofile', params: { username: data.item._id.username } }"
            >
              {{ data.item._id.username }}
            </b-link>
          </template>
          <template #cell(userType)="data">
            {{ data.item._id.userType }}
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="dataMeta.currentPage"
                :total-rows="dataMeta.total"
                :per-page="dataMeta.perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @change="retrieveProfiles"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </b-row>
  </b-form>
</template>

<script>
import { mapActions } from 'vuex'
import router from '@/router'

import {
  BRow, BCol, BForm, BCard, BLink, BTable, BPagination, BAvatar,
} from 'bootstrap-vue'

export default {
  components: {
    BRow, BCol, BForm, BCard, BTable, BLink, BPagination, BAvatar,
  },
  data() {
    return {
      activityTable: null,
      isLoading: false,
      searchQuery: '',
      dataMeta: {
        currentPage: 1,
        perPage: 14,
        total: 3,
      },
      tableColumns: [
        { key: 'profileImage', label: 'profile', sortable: true },
        { key: 'username', label: 'Username', sortable: true },
        { key: 'userType', label: 'User Type', sortable: true },
        { key: 'createdAt', label: 'Start Follow', sortable: true },
      ],
    }
  },
  mounted() {
    this.retrieveUserFollowers()
  },
  methods: {
    ...mapActions({
      retrieveUserFollowersAction: 'profile/retrieveUserFollowers',
    }),
    retrieveUserFollowers() {
      const data = {
        id: router.currentRoute.params.id,
        page: this.dataMeta.currentPage,
        perPage: this.dataMeta.perPage,
        sortBy: 'createdAt',
        sortDesc: 1,
      }
      this.retrieveUserFollowersAction(data).then(response => {
        this.activityTable = response.data.data.followers
        this.dataMeta.total = response.data.total
        this.isLoading = true
      })
    },

  },
}
</script>

<style>

</style>
